const MachProIntl = Mach.requireModule('Intl');
export interface CurrencySymbolOptions {
  currency: string;
  currencyDisplay?: 'narrowSymbol' | 'symbol' | 'code' | 'name';
}
function getCurrencySymbol(options: CurrencySymbolOptions) {
  const { currency, currencyDisplay = 'narrowSymbol' } = options;

  const formatZero = MachProIntl.formatNumber({
    number: 0,
    style: 'currency',
    currencyCode: currency,
    currencyStyle: currencyDisplay,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return `${formatZero}`.replace(/\d|\./g, '').trim();
}

export default getCurrencySymbol;
